import { on } from 'delegated-events'

const SELECTORS = Selectors({
  sidebar: 'page-sidebar',
  collapsable: 'page-sidebar-collapsable',
  menuToggle: 'page-sidebar__title button',
  section: 'page-sidebar .has-submenu',
  sectionToggle: 'page-sidebar .has-submenu button'
})

const $sidebar = document.querySelector(SELECTORS.asClass('sidebar'))
const $collapsable = document.querySelectorAll(SELECTORS.asClass('collapsable'))
const $menuToggle = document.querySelector(SELECTORS.asClass('menuToggle'))

const fn = {
  init: () => {
    fn.bindEvents()
  },

  bindEvents: () => {
    on('click', SELECTORS.asClass('menuToggle'), () => {
      $($collapsable).slideToggle('fast', () => {
        $menuToggle.classList.toggle('is-active')
      })
    })

    on('click', SELECTORS.asClass('sectionToggle'), function (e) {
      const $section = e.target.closest(SELECTORS.asClass('section'))

      $($section).find('ul').first().slideToggle('fast', () => {
        $section.classList.toggle('is-active')
      })
    })
  },
}

export default {
  can: () => $sidebar,
  run: fn.init
}
